// Mapping Sets
export const GET_MAPPING_SETS_REQUEST = 'GET_MAPPING_SETS_REQUEST';
export const GET_MAPPING_SETS_SUCCESS = 'GET_MAPPING_SETS_SUCCESS';
export const GET_MAPPING_SETS_ERROR = 'GET_MAPPING_SETS_ERROR';

export const GET_MAPPING_SETS_BY_VENDOR_REQUEST = 'GET_MAPPING_SETS_BY_VENDOR_REQUEST';
export const GET_MAPPING_SETS_BY_VENDOR_SUCCESS = 'GET_MAPPING_SETS_BY_VENDOR_SUCCESS';
export const GET_MAPPING_SETS_BY_VENDOR_ERROR = 'GET_MAPPING_SETS_BY_VENDOR_ERROR';

export const GET_MAPPING_SET_REQUEST = 'GET_MAPPING_SET_REQUEST';
export const GET_MAPPING_SET_SUCCESS = 'GET_MAPPING_SET_SUCCESS';
export const GET_MAPPING_SET_ERROR = 'GET_MAPPING_SET_ERROR';

export const CREATE_MAPPING_SET_REQUEST = 'CREATE_MAPPING_SET_REQUEST';
export const CREATE_MAPPING_SET_SUCCESS = 'CREATE_MAPPING_SET_SUCCESS';
export const CREATE_MAPPING_SET_ERROR = 'CREATE_MAPPING_SET_ERROR';

export const UPDATE_MAPPING_SET_REQUEST = 'UPDATE_MAPPING_SET_REQUEST';
export const UPDATE_MAPPING_SET_SUCCESS = 'UPDATE_MAPPING_SET_SUCCESS';
export const UPDATE_MAPPING_SET_ERROR = 'UPDATE_MAPPING_SET_ERROR';

export const DELETE_MAPPING_SET_REQUEST = 'DELETE_MAPPING_SET_REQUEST';
export const DELETE_MAPPING_SET_SUCCESS = 'DELETE_MAPPING_SET_SUCCESS';
export const DELETE_MAPPING_SET_ERROR = 'DELETE_MAPPING_SET_ERROR';

export const MAPPING_SETS_SAVE_ALL_REQUEST = 'MAPPING_SETS_SAVE_ALL_REQUEST';
export const MAPPING_SETS_SAVE_ALL_SUCCESS = 'MAPPING_SETS_SAVE_ALL_SUCCESS';
export const MAPPING_SETS_SAVE_ALL_ERROR = 'MAPPING_SETS_SAVE_ALL_ERROR';

// Mapping Rules
export const GET_MAPPING_SET_RULES_REQUEST = 'GET_MAPPING_SET_RULES_REQUEST';
export const GET_MAPPING_SET_RULES_SUCCESS = 'GET_MAPPING_SET_RULES_SUCCESS';
export const GET_MAPPING_SET_RULES_ERROR = 'GET_MAPPING_SET_RULES_ERROR';

export const CREATE_MAPPING_RULE_REQUEST = 'CREATE_MAPPING_RULE_REQUEST';
export const CREATE_MAPPING_RULE_SUCCESS = 'CREATE_MAPPING_RULE_SUCCESS';
export const CREATE_MAPPING_RULE_ERROR = 'CREATE_MAPPING_RULE_ERROR';

export const UPDATE_MAPPING_RULE_REQUEST = 'UPDATE_MAPPING_RULE_REQUEST';
export const UPDATE_MAPPING_RULE_SUCCESS = 'UPDATE_MAPPING_RULE_SUCCESS';
export const UPDATE_MAPPING_RULE_ERROR = 'UPDATE_MAPPING_RULE_ERROR';

export const DELETE_MAPPING_RULE_REQUEST = 'DELETE_MAPPING_RULE_REQUEST';
export const DELETE_MAPPING_RULE_SUCCESS = 'DELETE_MAPPING_RULE_SUCCESS';
export const DELETE_MAPPING_RULE_ERROR = 'DELETE_MAPPING_RULE_ERROR';

// Value Transforms
export const GET_VALUE_TRANSFORMS_REQUEST = 'GET_VALUE_TRANSFORMS_REQUEST';
export const GET_VALUE_TRANSFORMS_SUCCESS = 'GET_VALUE_TRANSFORMS_SUCCESS';
export const GET_VALUE_TRANSFORMS_ERROR = 'GET_VALUE_TRANSFORMS_ERROR';

export const CREATE_VALUE_TRANSFORM_REQUEST = 'CREATE_VALUE_TRANSFORM_REQUEST';
export const CREATE_VALUE_TRANSFORM_SUCCESS = 'CREATE_VALUE_TRANSFORM_SUCCESS';
export const CREATE_VALUE_TRANSFORM_ERROR = 'CREATE_VALUE_TRANSFORM_ERROR';

export const UPDATE_VALUE_TRANSFORM_REQUEST = 'UPDATE_VALUE_TRANSFORM_REQUEST';
export const UPDATE_VALUE_TRANSFORM_SUCCESS = 'UPDATE_VALUE_TRANSFORM_SUCCESS';
export const UPDATE_VALUE_TRANSFORM_ERROR = 'UPDATE_VALUE_TRANSFORM_ERROR';

export const DELETE_VALUE_TRANSFORM_REQUEST = 'DELETE_VALUE_TRANSFORM_REQUEST';
export const DELETE_VALUE_TRANSFORM_SUCCESS = 'DELETE_VALUE_TRANSFORM_SUCCESS';
export const DELETE_VALUE_TRANSFORM_ERROR = 'DELETE_VALUE_TRANSFORM_ERROR';

// Vendor
export const GET_VENDORS_REQUEST = 'GET_VENDORS_REQUEST';
export const GET_VENDORS_SUCCESS = 'GET_VENDORS_SUCCESS';
export const GET_VENDORS_ERROR = 'GET_VENDORS_ERROR';

export const GET_VENDOR_REQUEST = 'GET_VENDOR_REQUEST';
export const GET_VENDOR_SUCCESS = 'GET_VENDOR_SUCCESS';
export const GET_VENDOR_ERROR = 'GET_VENDOR_ERROR';

export const CREATE_VENDOR_REQUEST = 'CREATE_VENDOR_REQUEST';
export const CREATE_VENDOR_SUCCESS = 'CREATE_VENDOR_SUCCESS';
export const CREATE_VENDOR_ERROR = 'CREATE_VENDOR_ERROR';

export const UPDATE_VENDOR_REQUEST = 'UPDATE_VENDOR_REQUEST';
export const UPDATE_VENDOR_SUCCESS = 'UPDATE_VENDOR_SUCCESS';
export const UPDATE_VENDOR_ERROR = 'UPDATE_VENDOR_ERROR';

export const DELETE_VENDOR_REQUEST = 'DELETE_VENDOR_REQUEST';
export const DELETE_VENDOR_SUCCESS = 'DELETE_VENDOR_SUCCESS';
export const DELETE_VENDOR_ERROR = 'DELETE_VENDOR_ERROR';